export const radii = { none: 0, sm: 6, md: 6, lg: 6, card: 12, pill: 999 } as const;

export type RadiusToken = keyof typeof radii;

export const r = (token: RadiusToken): string => `${radii[token]}px`;
